import React from 'react';
interface PageHeaderProps {
  title: string;
  description?: string;
}
export function PageHeader({
  title,
  description
}: PageHeaderProps) {
  return <div className="mb-6" data-id="element-85">
      <h1 className="text-2xl font-bold text-gray-900" data-id="element-86">{title}</h1>
      {description && <p className="mt-1 text-gray-500" data-id="element-87">{description}</p>}
    </div>;
}